import React, { PureComponent } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { withi18n } from "../../../../customer/components";
class SplitScreenContainer extends PureComponent {
  render() {
    const {
      t,
      classes,
      children,
      title,
      leftAdornment
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.splitScreenContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.leftChildContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: `${classes.headingWrapper} ${leftAdornment ? "" : classes.noAdornment}`
    }, leftAdornment && leftAdornment, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, t(title))), /*#__PURE__*/React.createElement("div", {
      className: classes.leftChildPadding
    }, children[0])), /*#__PURE__*/React.createElement("div", {
      className: classes.rightChildContainer
    }, children[1]));
  }
}
const styles = theme => ({
  splitScreenContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    overflowY: "auto",
    overflowX: "hidden",
    height: "calc(100vh - 64px)",
    width: "100%"
  },
  leftChildContainer: {
    paddingTop: 40,
    width: 450,
    minWidth: 450,
    position: "relative",
    flexDirection: "column",
    justifyContent: "flex-start",
    overflowY: "auto",
    overflowX: "hidden"
  },
  leftChildPadding: {
    paddingLeft: 20
  },
  headingWrapper: {
    display: "flex",
    alignItems: "center"
  },
  noAdornment: {
    paddingLeft: 20
  },
  rightChildContainer: {
    width: "100%",
    overflowX: "hidden"
  }
});
export default withStyles(styles)(withi18n(SplitScreenContainer));
SplitScreenContainer.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  leftAdornment: PropTypes.element
};